import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import supabase from '../../../supabase-client';
import Icon from '../AppIcon';
import Button from './Button';
import Input from './Input';
import SearchModal from './SearchModal';
import logo from '/assets/images/logo.png';

const CustomerHeader = ({ cartItemCount = 0, isAuthenticated = false, userName = '', onSearch }) => {
  const [isSearchExpanded, setIsSearchExpanded] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleSearchSubmit = (e) => {
    e?.preventDefault();
    const query = searchQuery?.trim();
    if (query && onSearch) {
      onSearch(query);
    }
  };

  const handleInputChange = (value) => {
    setSearchQuery(value);
  };

  const handleSearchClick = () => {
    setIsSearchModalOpen(true);
  };

  const handleSearchToggle = () => {
    setIsSearchModalOpen(true);
  };

  const handleLogout = () => {
    console.log('Logging out...');
    setIsUserMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-primary border-b border-border sm:border-white">
      <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-8">
        <div className="flex items-center justify-between h-14 sm:h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center flex-shrink-0">
            <img
              src={logo}
              alt="Logo"
              className="h-10 w-auto object-contain sm:h-14"
              style={{ maxHeight: '56px' }}
            />
          </Link>

          {/* Desktop Search */}
          <div className="hidden md:flex flex-1 max-w-lg mx-4 lg:mx-8 relative">
            <form onSubmit={handleSearchSubmit} className="w-full">
              <div className="relative">
                <Input
                  type="search"
                  placeholder="Buscar libros cristianos..."
                  value={searchQuery}
                  onClick={handleSearchClick}
                  onChange={(e) => handleInputChange(e?.target?.value)}
                  className="w-full pl-10 pr-4 py-2 bg-white/10 border-white/20 text-primary-foreground placeholder-white/70 focus:bg-white focus:text-foreground focus:placeholder-muted-foreground cursor-pointer"
                  readOnly
                />
                <Icon
                  name="Search"
                  size={20}
                  className="absolute left-3 top-1/2 transform -translate-y-1/2 text-white/70"
                />
              </div>
            </form>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-4 lg:space-x-6">
            <div className="flex items-center space-x-2 lg:space-x-3">
              <Link to="/login-screen">
                <Button variant="outline" className="border-white/30 text-primary-foreground hover:bg-white hover:text-primary text-xs sm:text-sm">
                  Administrador
                </Button>
              </Link>
            </div>
          </div>

          {/* Mobile Actions */}
          <div className="flex md:hidden items-center space-x-1 sm:space-x-2">
            <Button
              variant="ghost"
              size="icon"
              onClick={handleSearchToggle}
              className="text-primary-foreground hover:text-accent hover:bg-white/10 p-1.5 sm:p-2"
            >
              <Icon name={isSearchExpanded ? "X" : "Search"} size={18} className="sm:w-5 sm:h-5" />
            </Button>

            <Button
              variant="ghost"
              size="icon"
              onClick={() => setIsUserMenuOpen(!isUserMenuOpen)}
              className="text-primary-foreground hover:text-accent hover:bg-white/10 p-1.5 sm:p-2"
            >
              <Icon name="User" size={18} className="sm:w-5 sm:h-5" />
            </Button>
          </div>
        </div>


        {/* Mobile User Menu */}
        {isUserMenuOpen && (
          <div className="md:hidden absolute left-0 right-0 top-14 sm:top-16 bg-popover border-b border-border shadow-modal py-2 z-40 slide-in-up">
            <Link
              to="/login-screen"
              className="block px-4 py-3 text-sm text-popover-foreground hover:bg-muted transition-smooth"
              onClick={() => setIsUserMenuOpen(false)}
            >
              <Icon name="UserPlus" size={16} className="inline mr-3" />
              Administrador
            </Link>
          </div>
        )}

        {/* Search Modal */}
        <SearchModal 
          isOpen={isSearchModalOpen} 
          onClose={() => setIsSearchModalOpen(false)} 
        />
      </div>
    </header>
  );
};

export default CustomerHeader;
